import { ArrowUpRight } from "lucide-react";

const items = [
  "Proactive delay detection",
  "Automated carrier claims",
  "Zero WISMO tickets",
  "Shopify native",
  "Customers told before they ask",
];

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-edge/70 bg-panel/60 py-3.5"
    data-testid="marquee"
  >
    <div className="marquee-track flex items-center gap-8">
      {[...items, ...items, ...items, ...items].map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-8 whitespace-nowrap font-mono text-xs uppercase tracking-[0.22em] text-slate-500"
        >
          {item}
          <ArrowUpRight className="h-3.5 w-3.5 text-mint/70" />
        </span>
      ))}
    </div>
  </div>
);
